import PropTypes from 'prop-types'
import CommodityCodeShape from 'components/supplier_show/prop_shapes/commodity_code'
export default PropTypes.shape({
  count: PropTypes.number,
  items: PropTypes.arrayOf(CommodityCodeShape)
})
